module.exports = __webpack_public_path__ + "img/location-icon.692b4a4e.svg";